import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type StepCardProps = {
  title: string;
  subTitle?: string;
  searchBar?: React.ReactNode;
  children: React.ReactNode;
};

export function StepCard({ title, subTitle, searchBar, children }: StepCardProps) {
  return (
    <Box w={'100%'} flex={1}>
      <Text size="displaySm" fw={FONT_WEIGHTS.semibold} c="gray.10" ml="xxs">
        {title}
      </Text>

      {subTitle && (
        <Text size="md" fw={FONT_WEIGHTS.medium} mt="xxxs" c="gray.10" ml="xxs">
          {subTitle}
        </Text>
      )}

      {searchBar && <Box mt="sm">{searchBar}</Box>}

      <Box mt="lg">{children}</Box>
    </Box>
  );
}
